import styled from 'styled-components'

export const Section = styled.section`
  width: 100%;
  min-height: 364px;
  margin-top: 148px;
  padding: 18px;
  background: #d9ddf0;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
`

export const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: stretch;
  justify-content: space-between;
  gap: 32px;
  @media (max-width: 900px) {
    flex-direction: column;
    align-items: center;
    gap: 40px;
  }
`

export const LeftCol = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-width: 320px;
`

export const Title = styled.h2`
  font-family: 'Inter', sans-serif;
  font-weight: 700;
  font-size: 28px;
  line-height: 100%;
  color: var(--blue6, #21105d);
  margin-bottom: 24px;
`

export const DownloadRow = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 49px;
`

export const DownloadText = styled.span`
  font-family: 'Inter', sans-serif;
  font-weight: 600;
  font-size: 16px;
  color: #495057;
  margin-right: 20px;
`

export const StoreLogos = styled.div`
  display: flex;
  align-items: center;
  gap: 36px;
`

export const AppButton = styled.button`
  width: 246px;
  height: 64px;
  border-radius: 10px;
  padding: 16px;
  gap: 10px;
  background: #5039dd;
  color: #fff;
  font-family: 'Inter', sans-serif;
  font-weight: 600;
  font-size: 16px;
  line-height: 22px;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 0;
  margin-bottom: 0;
  transition: background 0.2s;
  &:hover {
    background: #3d2db3;
  }
`

export const RightCol = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: flex-end;
  min-width: 320px;
  position: relative;
  @media (max-width: 900px) {
    align-items: center;
    justify-content: center;
    min-width: unset;
  }
`

export const PhoneImg = styled.div`
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  z-index: 2;
`

export const TabletImg = styled.div`
  top: 5px;
  right: 0;
  z-index: 1;
  @media (max-width: 900px) {
    position: static;
    margin-top: 16px;
    right: unset;
  }
`
